// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2VYC-SFmlJbBM_1JNcczQ4","container-hyperlink":"_1peXFbE7w-XNTQQlsLGF9c","margin-right-10":"_30FQ_WZv14TolP3dz4x1ZS"};